import React, { useState } from 'react';
import {
  Paper,
  Chip,
  ButtonGroup,
  Button,
} from '@mui/material';
import {
  Link as RouterLink,
  MemoryRouter,
} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';

import Dialog from '@mui/material/Dialog';

import Form, {
  ButtonItem,
  GroupItem,
  SimpleItem,
  Label,
  CompareRule,
  EmailRule,
  PatternRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
  AsyncRule,
  Item,
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import 'devextreme-react/autocomplete';

import utils from '../utils'
import ServiceUserForm from './ServiceUserForm';
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import TextBox from 'devextreme-react/text-box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

// ************************************************************
// ************************************************************
// ************************************************************

export const ServiceUserAddComponentWrapper = (props) => {
  const navigate = useNavigate()
  return <ServiceUserAdd 
    navigate={navigate} 
    {...props} />
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  // https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
class ServiceUserAdd extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      errorMessage: undefined,
      completed: false,
      resellersRows: [],
      resellersLoading: true,
      computerInfo: undefined,
      add_to: {
        username: "",
        email: "",
      },
      user_TEST: {
        first_name: 'massi',
        last_name: 'massi',
        reseller_id: 46083,
        username: 'massi123',
        password: '123123123',
        confirm_password: '123123123',
        company_name: 'test1',
        company_address: '123123',
        company_city: "Altona",
        company_state: "Victoria",
        company_country: "Australia",
        email: 'landi.dev1@gmail.com',
        phone: '0039000123',
        accepted_terms: true,
        accepted_privacy_policy: true,
        LR_user_code: '3784283674',
        supplier_name: 'CARGAS 123',
        company_vat_number: '001122',
      },
      user: {
        first_name: '',
        last_name: '',
        reseller_id: undefined,
        username: '',
        password: '',
        confirm_password: '',
        company_name: '',
        company_address: '',
        company_city: undefined,
        company_state: undefined,
        company_country: undefined,
        email: '',
        phone: '',
        accepted_terms: false,
        accepted_privacy_policy: false,
        LR_user_code: '',
        supplier_name: '',
        company_vat_number: '',
      },
    }
  }
  componentDidMount() {
    console.log("bearer_value: ", this.props.bearer_value)

    AuthService.getResellerList(this.props.bearer_value).then(data => {
      if (data.is_valid) {
        var i = 1
        var rows = data.rows.map(row => {
          row.row_num = i++
          row.view_text = `${row.company_name} (${row.company_country})`
          return row
        })
        this.setState({
          resellersRows: rows,
          resellersLoading: false,
        })
      } else {
        //console.log(data)
        this.setState({ resellersLoading: false })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ resellersLoading: false })
    })

    AuthService.getComputerInfo(this.props.bearer_value).then(data => {
      if (data.is_valid) {
        console.log(data.payload)
        this.setState({
          computerInfo: data.payload,
          loading: false,
        })
      } else {
        console.log(data)
        this.setState({ 
          errorMessage: data.message,
          loading: false,
        })
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        errorMessage: "Unknown error",
        loading: false,
      })
    })
  }
  // funzione per visualizzare un messaggio che poi scompare in automatico
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }  
  getUser() {
    return this.state.user
    //return this.state.user_TEST
  }
  new_user_form_btn_submit_click() {
    console.log("NEW USER", this.getUser())    
    this.setState({ loading: true })
    AuthService.addServiceUser(this.getUser()).then(data => {
      if (data.is_valid) {
        this.props.navigate("/service/user/list")
      } else {
        console.log("data" , data)
        this.setState({ loading: false })
        this.notifySomething(data.message, "error")
      }
    }).catch(e => {
      console.log(e)
      this.setState({ loading: false })
      this.notifySomething("Unknown error", "error")
    })  
  }
  render() {
    if (this.state.loading) return <LoadingSpinner />
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    
    return (
      <>
        <div>
          <div className="container-sm">            
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={0} >
                    <Tab label="Create a new account" {...a11yProps(0)} />
                  </Tabs>
                </Box>
                <TabPanel value={0} index={0}>
                  {/* create new */}
                  <ServiceUserForm
                    btn_submit_click={this.new_user_form_btn_submit_click.bind(this)}
                    newUser={true}
                    isAdmin={false}
                    isReseller={false}
                    readOnly={false}
                    user={this.getUser()}
                    hideAgrees={true}
                    resellersRows={this.state.resellersRows}
                    />
                </TabPanel>
              </Box>

          </div>
        </div>
      </>
    )
  }
}
